import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { ApiResponse, Client } from 'app/entities';
import { map } from 'rxjs/operators';
import { Quote } from 'app/entities/quote';
import { ProposalLog } from 'app/entities/proposal-log';

@Injectable({
  providedIn: 'root',
})
export class QuotesService extends ApiService {
  findAll(params: any = {}) {
    params = {
      ...(params ?? {}),
      only_without_proposal: true,
    };
    params = this.paramsFromObject(params);
    return this.httpService.get(`/v1/clients/quotes`, params).pipe(map((res) => ApiResponse.parseWith(new Quote(), res) as ApiResponse<Quote[]>));
  }

  find(id: any) {
    return this.httpService.get(`/v1/clients/quotes/${id}`).pipe(map((res) => Quote.parse(res.data) as Quote));
  }

  proposalDraft(id: number) {
    return this.httpService.post(`/v1/clients/quotes/${id}/proposal-draft`, {}).pipe(map((res) => res.data));
  }

  destroy(id: number) {
    return this.httpService.delete(`/v1/clients/quotes/${id}`);
  }
}
